import { useEffect, useRef } from 'react';

// Closes an overlay on Escape and marks the key consumed; pass enabled=false while
// submitting or while another modal is stacked on top (both would close otherwise).
export function useEscapeKey(onEscape: () => void, enabled: boolean): void {
    const handlerRef = useRef(onEscape);

    useEffect(() => {
        handlerRef.current = onEscape;
    }, [onEscape]);

    useEffect(() => {
        if (!enabled) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key !== 'Escape') return;
            // Marks Escape as consumed so page-level listeners leave it alone.
            event.preventDefault();
            handlerRef.current();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [enabled]);
}
